/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import resolverConfigurationFieldsetTemplate from './resolver-configuration-fieldset.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ResolverConfigurationDirective($compile, $templateCache, $translate, $log, types, toast) {
    var linker = function (scope, element) {
        var template = $templateCache.get(resolverConfigurationFieldsetTemplate);
        element.html(template);

        scope.weightingMethods = types.weightingMethod;
        scope.antennaCombiningMethods = types.antennaCombiningMethod;

        scope.onResolverConfigurationCopied = function() {
            toast.showSuccess(
                $translate.instant('resolver-configuration.id-copied-message'),
                750,
                angular.element(element).closest(".toast-parent"),
                'bottom left'
            );
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "E",
        link: linker,
        scope: {
            resolverConfiguration: '=',
            isEdit: '=',
            theForm: '='
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/resolver-configuration/resolver-configuration.directive.js